import { GET, POST, domainRoutes } from 'constants/api';
import { mailerServiceApi } from './api';

export const getAllIpPoolMappings = () =>
  mailerServiceApi({
    method: GET,
    url: domainRoutes.GET_ALL_IP_POOL_MAPPINGS,
  });

export const setIpPool = data =>
  mailerServiceApi({
    method: POST,
    url: domainRoutes.SET_IP_POOL_MAPPING,
    data,
  });
